import {ssrLazy} from 'ssr/lazy';

export const TextWithImageLazy = ssrLazy(() => import(/* webpackChunkName: "textWithImageSSR" */ 'app/components/textWithImageSSR'));
